
































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Announcement from "@/models/annoucement/annoucement.Model";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import BaseModel from "../../models/base/BaseModel.model";
import Annoucement from "@/models/annoucement/annoucement.Model";
import { Utils } from "@/core/Utils";
import { url } from "inspector";
import AnnoucementResearchArea from "@/models/annoucement/annoucementResearchArea.model";
import GenericEdit from "../../core/Generics/GenericEdit";
import moment from "moment";
import TipoEvaluacionService from "@/services/TipoEvaluacion.service";
import TipoEvaluacion from "@/models/evaluacion/tipoEvaluacion.model";
import { ParesEvaluadoresTypes } from "@/enums/ParesEvaluadoresTypes";
import AnnoucementEvaluationType from "@/models/annoucement/annoucementEvaluationType.Model";
import AnnoucementRequiredEvaluationType from "@/models/annoucement/annoucementRequiredEvaluationType.Model";
import BaseTreeSelect from "@/components/base/baseTreeSelect/baseTreeSelectCustom.vue";
import AreaService from '@/services/Area.service';

@Component({
  components: { BaseTreeSelect }
})
export default class AnnouncementEditWizard extends GenericEdit<Announcement> {
  currentAnnoucementResearchLine = new AnnoucementResearchArea();
  showWeekNumber = false;
  formatAmPm = false;
  enableSeconds = false;
  areaHistorys = [];
  areaNotHistorys = [];
  public monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  public dayNames = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"];
  public formatDateTime(date: string) {
    if (date) return moment(date).format("DD/MM/YYYY HH:mm");
  }
  areaService: AreaService = new AreaService();

  // tipos de evaluaciones
  tipoEvaluacionService: TipoEvaluacionService = new TipoEvaluacionService();
  evaluationTypes: Array<TipoEvaluacion> = [];
  cientificoTecnicoType: ParesEvaluadoresTypes =
    ParesEvaluadoresTypes.CIENTIFICOTECNICO;
  mainEvaluationId: number = null;
  evaluacionAEliminar: any = {
    evaluationId: 0,
    requiredEvaluationId: 0
  };


  created() {
    // aqui debo rellenar la
    this.getAllHistoryArea();
    this.getAllNotHistoryArea();
  }
 

  constructor() {
    super();
    this.controller = "Annoucements";
    this.model = new Announcement();
    Quill.register("modules/imageDrop", ImageDrop);
  }
 getAllHistoryArea(){
      this.areaService.GetHistoryArea().then(response =>{
            this.areaHistorys = response; 
      })
    }
    getAllNotHistoryArea(){
       this.areaService.GetNotHistoryArea().then(response =>{
            this.areaNotHistorys = response; 
      })
    }
  // public onSelectRequiredEvaluations(value, selected) {
  //   this.evaluationTypes.forEach(evaluationType => {
  //     if (evaluationType.id == value.id) {
  //       evaluationType.checkedUI = true;
  //       evaluationType.disabledUI = true;
  //     }
  //   });
  // }

  requiredEvaluationValidator(currentEvaluationId, requiredEvaluation) {
    if (requiredEvaluation) {
      let evaluationType = this.evaluationTypes.find(
        x => x.id == requiredEvaluation
      );
      if (
        evaluationType.requiredEvaluationTypesUI &&
        evaluationType.requiredEvaluationTypesUI.some(
          x => x == currentEvaluationId
        )
      ) {
        return true;
      } else {
        for (
          let i = 0;
          i < evaluationType.requiredEvaluationTypesUI.length;
          i++
        ) {
          const evaluation = evaluationType.requiredEvaluationTypesUI[i];
          let result = this.requiredEvaluationValidator(
            currentEvaluationId,
            evaluation
          );
          if (result) return true;
        }
      }
    }
    return false;
  }

  public onSelectRequiredEvaluations(value, selected, evaluation) {
    let currentEvaluationIsParentOfTheValue = this.evaluationTypes.some(
      (x:any) =>
        x.id == value.id &&
        x.requiredEvaluationTypesUI.find(y => y == evaluation.id)
    );

    let requiredEvaluationTypes = this.evaluationTypes.find(
       (x:any) => x.id == value.id
    ).requiredEvaluationTypesUI;
    requiredEvaluationTypes.forEach(requiredEvaluationType => {
      if (
        this.requiredEvaluationValidator(evaluation.id, requiredEvaluationType)
      ) {
        this.evaluacionAEliminar.evaluationId = evaluation.id;
        this.evaluacionAEliminar.requiredEvaluationId = value.id;
        this.operationNoAllowed(`Operación no permitida`, 5000);
        return;
      }
    });

    if (!currentEvaluationIsParentOfTheValue) {
      this.evaluationTypes.forEach(evaluationType => {
        if (evaluationType.id == value.id) {
          evaluationType.checkedUI = true;
          evaluationType.disabledUI = true;
        }
      });
    } else {
      if (evaluation && selected) {
        this.evaluacionAEliminar.evaluationId = evaluation.id;
        this.evaluacionAEliminar.requiredEvaluationId = value.id;
        this.operationNoAllowed(
          `Operación no permitida, el ${evaluation.titulo} ya es una evaluación requerida del ${selected.titulo}`,
          5000
        );
      }
    }
  }

  public onDeselectRequiredEvaluations(value) {
    let counter = 0;
    this.evaluationTypes.forEach(evaluationType => {
      evaluationType.requiredEvaluationTypesUI.forEach(
        requiredEvaluationTypeUI => {
          if (value.id == requiredEvaluationTypeUI) counter++;
        }
      );
    });
    if (counter < 2) {
      this.evaluationTypes.forEach(evaluationType => {
        if (evaluationType.id == value.id) {
          evaluationType.disabledUI = false;
        }
      });
    }
  }

  public onComplete() {
    let checkedEvaluationTypes: TipoEvaluacion[] = this.evaluationTypes.filter(
      x => x.checkedUI
    );
    this.model.annoucementEvaluationsTypes.forEach(
      annoucementEvaluationType => {
        if (
          !checkedEvaluationTypes.some(
            x => x.id === annoucementEvaluationType.evaluationTypeId
          )
        )
          annoucementEvaluationType.deleted = true;
      }
    );
    checkedEvaluationTypes.forEach((checkedEvaluationType: TipoEvaluacion) => {
      if (
        this.model.annoucementEvaluationsTypes.some(
          x => x.evaluationTypeId === checkedEvaluationType.id
        )
      ) {
        let dbAnnouncementEvaluationType: AnnoucementEvaluationType = this.model.annoucementEvaluationsTypes.find(
          x => x.evaluationTypeId === checkedEvaluationType.id
        );
        dbAnnouncementEvaluationType.isMainEvaluation =
          this.mainEvaluationId === checkedEvaluationType.id ? true : false;
        dbAnnouncementEvaluationType.minimumNumberOfEvaluators =
          checkedEvaluationType.minimumNumberOfEvaluatorsUI;
        dbAnnouncementEvaluationType.annoucementRequiredEvaluationTypes.forEach(
          (
            dbAnnoucementRequiredEvaluationType: AnnoucementRequiredEvaluationType
          ) => {
            if (
              !checkedEvaluationType.requiredEvaluationTypesUI.some(
                x => x === dbAnnoucementRequiredEvaluationType.evaluationTypeId
              )
            ) {
              dbAnnoucementRequiredEvaluationType.deleted = true;
            }
          }
        );
        checkedEvaluationType.requiredEvaluationTypesUI.forEach(
          requiredEvaluationTypeUI => {
            if (
              !dbAnnouncementEvaluationType.annoucementRequiredEvaluationTypes.some(
                x => x.evaluationTypeId === requiredEvaluationTypeUI
              )
            ) {
              let annoucementRequiredEvaluationType = new AnnoucementRequiredEvaluationType();
              annoucementRequiredEvaluationType.evaluationTypeId = requiredEvaluationTypeUI;
              dbAnnouncementEvaluationType.annoucementRequiredEvaluationTypes.push(
                annoucementRequiredEvaluationType
              );
            }
          }
        );
      } else {
        let annoucementEvaluationType = new AnnoucementEvaluationType();
        annoucementEvaluationType.evaluationTypeId = checkedEvaluationType.id;
        annoucementEvaluationType.isMainEvaluation =
          this.mainEvaluationId === checkedEvaluationType.id ? true : false;
        annoucementEvaluationType.minimumNumberOfEvaluators =
          checkedEvaluationType.minimumNumberOfEvaluatorsUI;
        checkedEvaluationType.requiredEvaluationTypesUI.forEach(
          (requiredEvaluationTypeId: number) => {
            let annoucementRequiredEvaluationType = new AnnoucementRequiredEvaluationType();
            annoucementRequiredEvaluationType.evaluationTypeId = requiredEvaluationTypeId;
            annoucementEvaluationType.annoucementRequiredEvaluationTypes.push(
              annoucementRequiredEvaluationType
            );
          }
        );
        this.model.annoucementEvaluationsTypes.push(annoucementEvaluationType);
      }
    });

    return this.validate();
  }

  protected async getData() {
    try {
      if (this.modelToEdit && !this.loadFromAPI) {
        this.modelToEdit.dateOpen = new Date(this.modelToEdit.dateOpen) as any;
        this.modelToEdit.dateEnd = new Date(this.modelToEdit.dateEnd) as any;

        this.model = this.map<Announcement>(this.modelToEdit);
      } else {
        this.loading = true;
        var modelo = await this.repository.byId(this.id, this.include);
        modelo.dateOpen = new Date(modelo.dateOpen);
        modelo.dateEnd = new Date(modelo.dateEnd);
        this.model = modelo;
        //
        this.tipoEvaluacionService.getAll().then((data: TipoEvaluacion[]) => {
          data.forEach((tipoEvaluacion: TipoEvaluacion) => {
            tipoEvaluacion.checkedUI = false;
            tipoEvaluacion.requiredEvaluationTypesUI = [];
            tipoEvaluacion.minimumNumberOfEvaluatorsUI =
              tipoEvaluacion.type == this.cientificoTecnicoType ? 2 : 1;
          });

          this.evaluationTypes = data;

          // merge between annoucement evaluationTypes and DB evaluationTypes
          this.model.annoucementEvaluationsTypes.forEach(
            annoucementEvaluationType => {
              this.evaluationTypes.forEach(dBEvaluationType => {
                if (
                  annoucementEvaluationType.evaluationTypeId ==
                  dBEvaluationType.id
                ) {
                  if (annoucementEvaluationType.isMainEvaluation)
                    this.mainEvaluationId =
                      annoucementEvaluationType.evaluationTypeId;
                  dBEvaluationType.checkedUI = true;
                  dBEvaluationType.requiredEvaluationTypesUI = annoucementEvaluationType.annoucementRequiredEvaluationTypes.map(
                    x => x.evaluationTypeId
                  );
                  dBEvaluationType.minimumNumberOfEvaluatorsUI =
                    annoucementEvaluationType.minimumNumberOfEvaluators;
                }
              });
            }
          );

          this.model.annoucementEvaluationsTypes.forEach(evaluationType => {
            if (evaluationType.annoucementRequiredEvaluationTypes.length > 0) {
              evaluationType.annoucementRequiredEvaluationTypes.forEach(
                requiredEvaluationType => {
                  this.evaluationTypes.forEach(evaluationTypeUI => {
                    if (
                      evaluationTypeUI.id ==
                      requiredEvaluationType.evaluationTypeId
                    ) {
                      evaluationTypeUI.disabledUI = true;
                    }
                  });
                }
              );
            }
          });
        });
      }

      this.modelInit = this.map<Announcement>(this.model);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  public termConditionSelected(value: BaseModel) {
    if (value.id != this.model.termCondictionId) {
      this.model.titleTermCondiction = value.title;
      this.model.descriptionTermCondiction = value.description;
    }
  }

  editorOption = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
        ["link", "image", "video"]
      ],
      imageDrop: true
    },
    placeholder: "Escriba el contenido aqui..."
  };

  public convertirAMinuscula(event: any) {
    this.model.key = event.target.value.toLowerCase();
  }

  public deleteResearchLine(annoucementResearchArea: AnnoucementResearchArea) {
    if (annoucementResearchArea.id) {
      annoucementResearchArea.deleted = true;
    } else {
      this.model.annoucementAreas = this.model.annoucementAreas.filter(
        x => x != annoucementResearchArea
      );
    }
  }

  addAnnoucementReserachLine() {
    if (this.currentAnnoucementResearchLine.researchLineId) {
      var newObject = Utils.mapToObject(
        this.currentAnnoucementResearchLine,
        new AnnoucementResearchArea()
      ) as AnnoucementResearchArea;
      this.model.annoucementAreas.push(newObject);

      this.currentAnnoucementResearchLine.init();
    } else {
      this.operationFailedErrors(["Debes seleccionar todos los campos"]);
    }
  }
}
